import { useMutation } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";

export const useResetMfa = () => {
  const resetMfa = useMutation({
    mutationFn: async ({ userId }) => {
      return makeApiRequest({
        endpoint: "/api/support/reset-mfa",
        method: "POST",
        body: { userId },
        json: true
      });
    }
  });

  return { resetMfa };
};
